import { NgModule } from '@angular/core';
import { CustomizeDesignService } from './customize-design.service';

@NgModule({
  providers: [CustomizeDesignService],
})
export class CustomizeDesignModule {}
